export class ProjectTemplate
{
    template:string;
}